import React, { useMemo } from 'react';
import { FlexboxGrid } from 'rsuite';
import { useSelector } from 'react-redux';
import {
  selectConfigExpressRegistrationMultiplePermitsPerAPNPolicy,
  selectConfigExpressRegistrationTypeVerbiage,
} from '../../store/slices/config/configSelectors';
import { MULTIPLE_PERMITS_PER_APN_POLICY_OPTIONS_ENUM } from '../../common/enums';
import Notice from '../user-feedback/Notice';

const GenericApplyWarning = ({ message }) => {
  const selectedPermitTypeVerbiage = useSelector(
    selectConfigExpressRegistrationTypeVerbiage
  );
  const multipleLicenseStatus = useSelector(
    selectConfigExpressRegistrationMultiplePermitsPerAPNPolicy
  );
  const noticeType = useMemo(() => {
    if (
      multipleLicenseStatus ===
      MULTIPLE_PERMITS_PER_APN_POLICY_OPTIONS_ENUM.WARN
    ) {
      return 'warning';
    } else {
      return 'error';
    }
  }, [multipleLicenseStatus, selectedPermitTypeVerbiage]);

  return (
    <FlexboxGrid>
      <FlexboxGrid.Item colspan={24}>
        <Notice
          type={noticeType}
          message={message}
        />
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default GenericApplyWarning;
